$(document).on('nc.sidePanel.shown', '[id*="data-side-panel-ledgers-create"], [id*="data-side-panel-ledgers-edit"]', function (e, result) {
    const form = document.getElementById('change-ledger-form');
    const submitButton = document.getElementById('change-ledger-btn');

    submitButton.addEventListener('click', function (e) {
        e.preventDefault();
        const ledgerNumber = document.getElementById('ledger_number').value;

        $.ajax({
            url: '/admin/settings/ledgers/exists/' + ledgerNumber,
            type: 'GET',
            success: function (response) {
                console.log(response);
                if (response.exists) {
                    // If dossiers are found, show the Bootstrap modal
                    let dossiersHtml = '';
                    response.dossiers.forEach(function (dossier) {
                        dossiersHtml += `<li><a href="${dossier.url}" target="_blank">${dossier.name}</a></li>`;
                    });

                    // Inject the dossiers into the modal body
                    $('#ledger-exists-modal-content').html(`<ul>${dossiersHtml}</ul>`);

                    $('#ledgerExistsModal').modal({
                        backdrop: false,
                        keyboard: true
                    });

                    // Show the Bootstrap modal
                    $('#ledgerExistsModal').modal('show');
                } else {
                    // If no dossiers found, submit the form directly
                    document.getElementById('change-ledger-btn-submit').click();
                }
            },
            error: function (response) {
                console.log(response);
            }
        });
    });

    $('#ledger-exists-confirm-btn').on('click', function () {
        document.getElementById('change-ledger-btn-submit').click();
    });

    $('#ledger-exists-cancel-btn').on('click', function () {
        $('#dossierModal').modal('hide');
    });

});
